// import React, {useEffect, useState} from "react";
// // import logo from '../assets/images/logos/logo_final_sim.svg'
// import logo from '../assets/images/logos/logo_final_sim_fondo.svg'
// import '../css/header.css'
// import Home from "../pages/home";
// import { Link } from 'react-router-dom';
// // import { useAuth } from '../hooks/useAuth';
// // import { useNavigate } from 'react-router-dom';
// // import { useLocation } from 'react-router-dom';
// import Nav from "./nav";

// const Header = ({formularios}) => {

//   const [isScrolled, setIsScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 50) { // Cambia 50 por el valor que desees
//         setIsScrolled(true);
//       } else {
//         setIsScrolled(false);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//     return (
//         <div className={`header ${isScrolled ? 'scrolled' : ''}`}>
//         <Link to="/"> {/* Redirige al home */}
//           <img src={logo} alt="Logo" className="logo-header" />
//         </Link>
//         <Nav formularios={formularios}/>
//       </div>
//     );
//   };
  
//   export default Header;

// header.jsx
import React, {useEffect, useState} from "react";
import logo from '../assets/images/logos/logo_final_sim_fondo.svg';
import '../css/header.css';
import { Link } from 'react-router-dom';
import Nav from "./nav";

const Header = ({ formularios }) => {
  const [isScrolled, setIsScrolled] = useState(false);


  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const headerBg = isScrolled
  ? "rgba(102, 171, 94, 0.41)"
  : "rgb(192, 220, 189)";

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="header__logoWrap">
        <img src={logo} alt="Logo" className="logo-header" />
      </Link>

      {/* 🔑 Esta “caja” limitará el ancho del nav */}
      <div className="header__navWrap">
        <Nav formularios={formularios} isScrolled={isScrolled} headerBg={headerBg}/>
      </div>
    </header>
  );
};

export default Header;
